<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      :padding="0">
      <p slot="title">发票模板</p>
    </Card>
    <div class="content">
      <Card
        style="height: 100%"
        class="smy__card-full card-left organizational"
        :bordered="false"
        :padding="0">
        <div class="options">
          <Button
            type="primary"
            style="width:100%"
            @click="isShowModal = true, isEdit = false"
            >新建发票模板
          </Button>
        </div>
        <div class="line"></div>
        <Menu
          style="width:300px"
          :active-name="active"
          @on-select="selectInvoiceType">
          <MenuItem
            style="padding:14px 10px; border-bottom: 1px solid #DDDEE1;"
            v-for="(orderList, index) in list"
            :key="orderList.id"
            :name="orderList.id">
            <span>{{orderList.name}}</span>
          </MenuItem>
        </Menu>
      </Card>
      <div class="smy__card-full card-right">
        <Card :bordered="false">
          <div class="top">
            <div class="top-right" style="float:right;">
              <Button
                type="primary"
                class="search-button"
                style="margin-left:10px;"
                @click="isShowModal = true, isEdit = true"
              >编辑</Button>
              <Button
                type="primary"
                class="search-button"
                style="margin-left:10px;"
                @click="deleteBtn"
              >删除</Button>
            </div>
          </div>
        </Card>
        <Card
          style="margin-top:10px"
          :bordered="false">
          <InvoiceTempleRight
            ref="orderDetailRight"
            :invoiceDetail="invoiceDetail"
            />
        </Card>
        <AddInvoice
          v-model="isShowModal"
          :isEdit="isEdit"
          :rowId="active"
          :invoiceDetail="invoiceDetail"
          @on-success="isEdit ? getInvoiceDetail() : loadList(), isEdit = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceTempleRight from './InvoiceTempleRight'
import AddInvoice from './AddInvoice'

export default {
  components: {
    InvoiceTempleRight,
    AddInvoice
  },
  data () {
    return {
      isShowModal: false,
      isEdit: false,
      list: [],
      pageIndex: 0,
      invoiceDetail: {},
      pageSize: 1000,
      active: 0
    }
  },
  watch: {
    active (val) {
      if (val) {
        this.getInvoiceDetail()
      }
    }
  },
  methods: {
    async loadList () {
      this.listLoading = true
      await this.$http.get('/invoiceTmpl/list', {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          ...this.searchForm
        }
      }).then(res => {
        this.list = res.data
      })
      if (this.list.length > 0) {
        this.active = this.list[0].id
      }
    },
    getInvoiceDetail () {
      this.$http.get(`/invoiceTmpl/info/${this.active}`).then(res => {
        this.invoiceDetail = res.data
      })
    },
    deleteBtn (event) {
      this.$Modal.confirm({
        title: '确定删除账单模板',
        content: '<p>确定删除该账单模板?</p>',
        onOk: () => {
          let url = `/invoiceTmpl?id=${this.active}`
          this.$http.delete(url).then(res => {
            if (res.success) {
              this.loadList()
              this.$Message.success('删除成功')
            } else {
              this.$Message.warning(res.message)
            }
          })
        }
      })
    },
    selectInvoiceType (id) {
      this.active = id
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.title{
  border-right: 1px solid #DDDEE1;
}
.organizational {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .service-group {
    display: flex;
    justify-content: space-between;
  }
  .options {
    width: 100%;
    text-align: left;
    padding: 14px;
  }
  .line {
    border-top: 1px solid rgb(221, 222, 225);
    .lineBtn{
      padding: 14px 10px 14px 0px;
      font-size: 14px;
    }
  }
}
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;
  .card-left {
    width: 300px;
    height: 100%;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceTemplate/index.vue